import { render, staticRenderFns } from "./tech-add-or-update.vue?vue&type=template&id=1b0b75ed&scoped=true"
import script from "./tech-add-or-update.vue?vue&type=script&lang=js"
export * from "./tech-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./tech-add-or-update.vue?vue&type=style&index=0&id=1b0b75ed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0b75ed",
  null
  
)

export default component.exports